<ng-template vdrDialogTitle>{{ "Add entrant info" | translate }}</ng-template>

<div style="width: 100%">
  <label class="mt-2">{{ "common.language" | translate }}</label>

  <div style="width: 100%; margin: 1rem">
    <vdr-language-selector
      [disabled]="false"
      [availableLanguageCodes]="availableLanguages"
      [currentLanguageCode]="selectedLanguage"
      (languageCodeChange)="setLanguage($event)"
    ></vdr-language-selector>
  </div>

  <p>
    {{
      "order.downloading"
        | translate
          : {
              count: total
            }
    }}
  </p>
</div>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <button type="submit" (click)="save()" class="btn btn-primary">
    {{ "common.okay" | translate }}
  </button>
</ng-template>
